import type { ReactNode } from 'react'

interface FieldItem {
  label: string
  value: ReactNode
  wide?: boolean
}

interface DocumentFieldGridProps {
  items: FieldItem[]
  columns?: 2 | 3
}

export default function DocumentFieldGrid({ items, columns = 2 }: DocumentFieldGridProps) {
  const columnClass = columns === 3 ? 'sm:grid-cols-3' : 'sm:grid-cols-2'

  return (
    <dl className={`grid gap-0 border border-slate-300 ${columnClass} sm:[grid-auto-rows:minmax(0,auto)]`}>
      {items.map((item) => (
        <div
          key={item.label}
          className={`border-b border-r border-slate-300 px-3 py-2 last:border-b-0 sm:last:border-b ${item.wide ? 'sm:col-span-2' : ''}`.trim()}
        >
          <dt className="text-[10px] font-semibold uppercase tracking-[0.24em] text-slate-500">{item.label}</dt>
          <dd className="mt-1 text-sm text-slate-900 whitespace-pre-line">{item.value}</dd>
        </div>
      ))}
    </dl>
  )
}
